<div class="flex justify-between bg-grey-veryLight mb-3 p-2">
	<app-button
		[icon]="ICON.BACK"
		size="small"
		(click)="beforeClose()"
		[testHook]="testHooks.BackToFileButton"
		>Back to file</app-button
	>
	<div class="flex items-center">
		<atomic-matter-type-icon
			[fileType]="matter?.fileType"
			[testHook]="testHooks.MatterTypeIcon"
		></atomic-matter-type-icon>
		<span class="mx-3">{{ matter.number }}</span>
		<span>{{ matter.name }}</span>
	</div>
</div>

<div
	*ngIf="
		missingQuoteSections?.length === 0 &&
		!sendError &&
		!fetchDataError &&
		!requiresLawyerSignup
	"
	class="flex flex-1"
>
	<div
		*ngIf="sendingData || gettingStatus || checkingAuth"
		class="flex flex-1 flex-col justify-center items-center"
	>
		<div class="w-64">
			<img src="/assets/images/integrations/fct-logo.svg" />
		</div>
		<div class="mt-10 flex items-center">
			<app-icon
				[icon]="ICON.LOADING"
				class="text-4xl mr-3 text-grey"
				[spin]="true"
				[testHook]="testHooks.LoadingIcon"
			></app-icon>
			<h4 class="text-grey">
				<span *ngIf="sendingData">Sending Data to FCT</span>
				<span *ngIf="gettingStatus">Updating order status</span>
				<span *ngIf="checkingAuth">Authenticating</span>
			</h4>
		</div>
	</div>

	<div
		class="flex flex-col flex-1 w-full"
		*ngIf="
			_url && !sendingData && !gettingStatus && !checkingAuth && !hideIframe
		"
	>
		<iframe
			id="llc-iframe"
			[src]="_url"
			width="100%"
			height="100%"
			class="flex flex-1"
			[testHook]="testHooks.LLCiFrame"
		></iframe>
	</div>

	<div
		*ngIf="!sendingData && !gettingStatus && !checkingAuth && hideIframe"
		class="flex flex-col flex-1 justify-center items-center"
	>
		<div class="flex flex-col flex-1 items-center justify-center">
			<div class="flex justify-center items-center">
				<img
					src="/assets/images/empty-states/external-window.svg"
					class="w-52 h-52"
				/>
			</div>
			<h4 class="block text-3xl">FCT Has Been Launched In Your Browser</h4>
			<p class="text-grey text-base mx-64 text-center">
				We're actively working to restore FCT's direct access in Closer. For
				now, please use FCT in your browser to submit orders, as well as to
				access your policy details and documents.
			</p>
		</div>
	</div>
</div>

<div
	*ngIf="requiresLawyerSignup"
	class="flex flex-1 h-full w-full items-center justify-center"
>
	<div class="border rounded-xl p-5 flex">
		<div class="border-r border-grey-lighter pr-5 flex flex-1 items-center">
			<app-icon
				[icon]="ICON.WARNING"
				class="text-7xl text-orange"
				[testHook]="testHooks.WarningIcon"
			></app-icon>
		</div>
		<div class="ml-10 text-center">
			<h4>Lawyer on file is not signed up to FCT</h4>
			<p class="mt-10">
				FCT requires that the lawyer on the matter to be signed up to FCT.
			</p>
			<p class="mt-3">
				Please communicate to
				<strong>{{ matter.lawyerAssigned.name }}</strong> they need to add their
				credentials in their profile below.
			</p>
			<!-- FT: Meeting: We don't need this -->
			<p class="flex flex-1 justify-center items-center my-10">
				<app-anchor
					type="pill"
					(click)="forceClose()"
					[url]="integrationsProfileSetupUrl"
					class="text-lg"
					[testHook]="testHooks.SetupFctCredentialsHereLink"
					>Setup FCT Credentials here</app-anchor
				>
			</p>
			<p>Once complete, close this modal and try again.</p>
		</div>
	</div>
</div>

<div
	*ngIf="fetchDataError"
	class="flex flex-col justify-center items-center flex-1"
>
	<p class="mb-2">
		We were unable to load the latest data into Closer from FCT.
	</p>
	<p class="mb-5">
		Please retry to ensure you have the latest title insurance information in
		your matter.
	</p>

	<div class="flex gap-5">
		<app-button
			btn="tertiary"
			size="small"
			(click)="forceClose()"
			[testHook]="testHooks.CloseButton"
			>Close</app-button
		>
		<app-button
			(click)="syncData()"
			size="small"
			[testHook]="testHooks.RetryButton"
			>Retry</app-button
		>
	</div>
</div>

<div *ngIf="sendError" class="flex flex-col justify-center items-center flex-1">
	<p class="mb-5">{{ sendError }}</p>
	<app-button
		(click)="checkAuthAndSendData()"
		size="small"
		[testHook]="testHooks.RetryButton1"
		>Retry</app-button
	>
</div>

<div
	*ngIf="missingQuoteSections?.length > 0"
	class="flex flex-col flex-1 justify-center items-center"
>
	<div class="w-64 mb-10">
		<img src="/assets/images/integrations/fct-logo.svg" />
	</div>
	<p class="mb-5 flex items-center">
		<app-icon
			class="text-orange text-4xl mr-5"
			[icon]="ICON.WARNING"
			[testHook]="testHooks.WarningIcon1"
		></app-icon>
		Unable request a quote from FCT. Please complete the following information
		to proceed.
	</p>
	<div class="rounded border-grey bg-grey-veryLight p-5">
		<div *ngFor="let section of missingQuoteSections">
			<h4 class="mb-5 text-left">{{ section.sectionName }}</h4>
			<div *ngFor="let field of section.fields" class="flex mt-2">
				<app-icon
					[icon]="ICON.ERROR"
					class="text-red mr-3"
					[testHook]="testHooks.ErrorIcon"
				></app-icon
				><app-anchor
					[url]="field.url"
					(click)="openUrl()"
					[queryParams]="backUrlParams"
					type="static"
					[testHook]="testHooks.Link"
					>{{ field.fieldName }}</app-anchor
				>
			</div>
		</div>
	</div>
</div>
